<template>
  <q-layout view="lHh Lpr lFf">
    <Header />
    <q-page-container>
      <q-page padding>
        <div class="row q-pt-lg text-grey-9">
          <div class="col"></div>
          <div class="col-5" style="max-width: 600px">
            <span class="text-h5">Email envoyé</span>
            <q-separator class="q-mt-sm"/>
            <div class="q-mt-lg">
              <p>
                Un email avec un lien pour réinitialiser le 
                mot de passe a été envoyé à l'adresse suivante :
              </p>
              <p class="text-weight-bold">
                {{ emailAdress }}
              </p>
            </div>
            <div>
              <q-btn
                label="Revenir à la connexion"
                to="/login"
                class="text-white bg-grey-9"
              />
            </div>
          </div>
          <div class="col"></div>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import Header from '~/components/Header';
import { notifyGlobalError } from '~/services/notify';

export default {
  props: ['email'],
  components: {
    Header,
  },
  data() {
    return {};
  },
  computed: {
    // a computed getter
    emailAdress: function () {
      return this.$props.email;
    }
  },
  beforeMount: async function() {
    if (!this.$props.email) {
      notifyGlobalError("Impossible d'accéder à cette page");
      this.$router.push({name: 'Page404'});
    }
  },
};
</script>
